import { call, put, race, take, delay, takeLatest } from "redux-saga/effects";
import { financialApi } from "../../../api/financial/financialApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IFinancialSummary } from "../../../model/respone/financial/IFinancialSummary";
import { eFinancialActionTypeIds } from "../../action-types/financial/IFinancialActions";
import { rootActions } from "../../actions/rootActions";

const POLL_INTERVAL_MS = 60_000;

export function* financialSaga(): any {
    // takeLatest — vào lại trang đăng ký thì hủy vòng lặp cũ, bắt đầu vòng mới.
    yield takeLatest(eFinancialActionTypeIds.LOAD_START, pollWorker);
}

/** Poll số dư mỗi 60s cho tới khi SV logout (AUTH_LOGOUT) hoặc saga bị takeLatest hủy. */
function* pollWorker(): any {
    while (true) {
        try {
            const res: IBaseRespone<IFinancialSummary> = yield call(financialApi.GetSummary);
            if (res.is_success && res.data) {
                yield put(rootActions.financial.LOAD_SUCCESS(res.data));
            } else {
                yield put(rootActions.financial.LOAD_ERROR(res.message || "Không tải được thông tin tài chính."));
            }
        } catch (e: any) {
            yield put(rootActions.financial.LOAD_ERROR(e?.message || "Lỗi kết nối."));
        }

        const { stop } = yield race({
            stop: take("AUTH_LOGOUT"),
            tick: delay(POLL_INTERVAL_MS),
        });
        if (stop) break;
    }
}
